import { useEffect } from "react"
import "./uploadAttachment.styles.css"
import videoLogo from '../../assets/images/video.svg'
import docLogo from '../../assets/images/document.svg'
import mp3Logo from '../../assets/images/Audio.svg'

export const UploadingAttachment = ({ file , removeAttachment}) => {

    const isUploading = file.isUploading

    let icon
    if(file.type == 'video/mp4') {
        icon = videoLogo
    }
    else if(file.type == "application/pdf") {
        icon = docLogo
    }
    else if(file.type == "audio/mpeg") {
        icon = mp3Logo
    }
    else {
        icon = file.path
    }
    return (
        <>
            { isUploading && <div className="card">
                <div className="card-header p-0">
                    <div className="card cen rounded-5 mb-0 uploading-logo" style={{ background: `url(${icon})`, width: "80px", height: "80px" }}></div>
                    <div className="progress-wrapper w-75">
                        <div id="example-caption-3">UPLOADING<span className="ml-2">{Math.floor(file.progress)}%</span>
                        </div>
                        <div className="progress progress-bar-primary">
                            <div className="progress-bar" role="progressbar" aria-valuenow="43" style={{width: `${file.progress}%`}}></div>
                        </div>
                    </div>
                    <div className="heading-elements mr-1">
                        <ul className="list-inline mb-0">
                            <li>
                                <a data-action="close" onClick={() => {
                                    file.cancelToken.cancel()
                                    removeAttachment(file.path)
                                    }}><i className="fas fa-times-circle text-p-light-blue font-20"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>}
        </>
    )
}